import { render } from "./HeaderComponent.vue?vue&type=template&id=1334a4a0"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import "./HeaderComponent.vue?vue&type=style&index=0&id=1334a4a0&lang=css"

import exportComponent from "C:\\Users\\SebastiánContreras\\OneDrive - Defensoría del Contribuyente\\Documents\\INGENIERIA DESARROLLO_TI\\REPOSITORIO_PROYECTOS\\AUTENTIFICACION_FRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__